// extracted by mini-css-extract-plugin
export var askAiIcon = "_kx-9";
export var container = "_kx-0";
export var groupSeparator = "_kx-a";
export var highlight = "_kx-4";
export var resultIcon = "_kx-5";
export var resultItem = "_kx-7";
export var resultSubtitle = "_kx-3";
export var resultTitle = "_kx-2";
export var resultsList = "_kx-1";
export var searchGroup = "_kx-6";
export var selected = "_kx-8";